import React, { createContext, useContext, useState, useEffect } from 'react';
import { getExchangeRate } from '../services/exchangeService';

interface CurrencyContext2Props {
  selectedCurrency: string;
  setSelectedCurrency: (currency: string) => void;
  buyRate: number | null;
  sellRate: number | null;
}

const CurrencyContext = createContext<CurrencyContext2Props | null>(null);

export const CurrencyProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedCurrency, setSelectedCurrency] = useState<string>('MIXTO');
  const [buyRate, setBuyRate] = useState<number | null>(null);
  const [sellRate, setSellRate] = useState<number | null>(null);

  useEffect(() => {
    const fetchRates = async () => {
      try {
        const data = await getExchangeRate('compra'); 
        const sellData = await getExchangeRate('venta');

        if (data && data.NUM_VALOR) {
          const buyRate = Number(data.NUM_VALOR); 
          setBuyRate(buyRate);
          localStorage.setItem('buyRate', buyRate.toString());
        }

        if (sellData && sellData.NUM_VALOR) {
          const sellRate = Number(sellData.NUM_VALOR); 
          setSellRate(sellRate);
          localStorage.setItem('sellRate', sellRate.toString());
        }
      } catch (error) {
        console.error('Error fetching exchange rates:', error);
        const storedBuyRate = localStorage.getItem('buyRate');
        const storedSellRate = localStorage.getItem('sellRate');
        
        if (storedBuyRate) {
          setBuyRate(Number(storedBuyRate));
        }
        if (storedSellRate) {
          setSellRate(Number(storedSellRate));
        }
      }
    };

    fetchRates();
  }, []); 

  return (
    <CurrencyContext.Provider value={{ selectedCurrency, setSelectedCurrency, buyRate, sellRate }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useCurrency must be used within a CurrencyProvider');
  }
  return context;
};
